import React from "react";

const Loading: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-custom-atrament bg-opacity-50 z-50 flex items-center justify-center">
      <div className="border-4 border-t-4 border-custom-atrament border-t-custom-blue-dark rounded-full w-16 h-16 animate-spin"></div>
    </div>
  );
};

export default Loading;
